import {Component, inject, Input} from '@angular/core';
import {KENDO_BUTTONS} from '@progress/kendo-angular-buttons';
import {BaseFilterCellComponent, FilterService} from '@progress/kendo-angular-grid';
import {KENDO_INPUTS} from '@progress/kendo-angular-inputs';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';

import {SimpleLibelleComponent} from "../../simple-libelle/simple-libelle.component";
import {ValLangueService} from '../../../../../../val-definitions-communes-lib/src/public-api';

//Composant filtre rapide boolean
@Component (
{
  selector: 'val-boolean-filtre-rapide',
  imports: 
  [
    KENDO_BUTTONS,
    KENDO_INPUTS,
    SimpleLibelleComponent
  ],
  templateUrl: './boolean-filtre-rapide.component.html',
  styleUrl: './boolean-filtre-rapide.component.scss',
})
export class BooleanFiltreRapideComponent extends BaseFilterCellComponent
{
  private valLangueService = inject (ValLangueService);

  //Texte d’interface traduit, ou texte d’origine si l’application ne porte pas la clé grille.<cle>
  //  Paramètres
  //    cle    : Clé sous grille.
  //    defaut : Texte d’origine
  public Texte (cle: string, defaut: string) : string
  {
    return this.valLangueService.TraduireOuDefaut ("grille." + cle, defaut);
  }

  //Création
  //  Paramètres
  //    filterService : Service filtres
  constructor (filterService: FilterService) 
  {
    super (filterService);

    this.valeur = null;
    this.valeurOui = false;
    this.valeurNon = false;
  }

  //Description des filtres
  @Input()
  public override filter!: CompositeFilterDescriptor;

  //Nom du champ
  @Input ()
  public nomChamp!: string;

  //Valeur
  public valeur: boolean | null;

  //Valeur oui
  public valeurOui: boolean;

  //Valeur non
  public valeurNon: boolean;

  //Retourne la valeur sélectionnée
  public get selectedValue () : any 
  {
    const filter = this.filterByField (this.nomChamp);

    return filter ? filter.value : null;
  }

  //Après l’initialisation du contenu
  public override ngAfterContentInit() : void 
  {
    const filter = this.filterByField (this.nomChamp);

    if (filter)
    {
      this.valeur = filter.value;

      if (this.valeur === false)
        this.valeurNon = true;

      if (this.valeur === true)
        this.valeurOui = true;
    }
  }

  //Exécute les actions sur changement de la checkbox oui
  public ChecBoxOuiChange () : void 
  {
    if ((this.valeur === null || !this.valeur) && this.valeurOui)
    {
      this.valeurNon = false;
      this.valeur = true;
    }
    else
    {
      this.valeur = null;
    }

    this.ChangerValeurFiltre ();
  }

  //Exécute les actions sur changement de la checkbox oui
  public ChecBoxNonChange () : void 
  {
    if ((this.valeur === null || this.valeur) && this.valeurNon)
    {
      this.valeurOui = false;
      this.valeur = false
    }
    else
    {
      this.valeur = null;
    }

    this.ChangerValeurFiltre ();
  }

  //Change la valeur du filtre
  private ChangerValeurFiltre () : void 
  {
    if (this.valeur === null)
    {
      this.applyFilter (this.removeFilter (this.nomChamp));
    }
    else
    {
      this.applyFilter (this.updateFilter (
                      {
                        field: this.nomChamp,
                        operator: "eq",
                        value: this.valeur
                      })
      );
    }
  }
}
